<template>
  <div>
    <div class="uk-flex uk-flex-between uk-flex-middle uk-margin-small-bottom">
      <p :class="['uk-text-bold uk-margin-remove', { ['uk-text-warning uk-flex uk-flex-middle']: error }]">
        <span v-if="error" style="margin-right: 6px" data-uk-icon="warning" />
        <span>Choose your size:</span>
      </p>
      <SizeChartButton :csrf="csrf" :product="product" :route="contactRoute" />
    </div>
    <div :class="[error ? 'uk-margin-small-bottom' : 'uk-margin-medium-bottom']">
      <div class="uk-child-width-1-5 uk-child-width-1-6@s uk-grid-small" data-uk-grid>
        <div v-for="size in product.sizes || []" :key="size.id">
          <label class="w-radio-label">
            <input
              v-model="selectedSize"
              class="uk-radio measureToAddToggle"
              type="radio"
              name="size"
              :value="size"
              required
              @change="error = false"
            />
            <span class="w-label uk-flex uk-flex-middle uk-flex-center">{{ size.short_name }}</span>
          </label>
        </div>
      </div>
      <p v-if="error" class="uk-text-warning uk-margin-small-top uk-margin-remove-bottom" style="font-size: 0.75rem">
        Please, choose your size!
      </p>
    </div>
    <div class="uk-margin uk-child-width-1-2@s uk-child-width-1-1@m uk-child-width-1-2@xl uk-grid-small" data-uk-grid>
      <div v-if="!product.isEditableOnly">
        <button
          :class="[
            'uk-button uk-button-default uk-width-1-1 uk-text-bold',
            { 'uk-button-secondary': !product.isEditable },
          ]"
          style="border-radius: 48px"
          type="button"
          @click="addToCart"
        >
          <span>Add to Cart</span>
        </button>
      </div>
      <div v-show="product.isEditable">
        <button
          class="uk-button uk-button-secondary uk-width-1-1 uk-text-bold"
          style="border-radius: 48px"
          type="button"
          @click="toWizard"
        >
          <span>Personalize</span>
        </button>
      </div>
    </div>

    <ul v-if="breakdownText" style="border-bottom: 1px solid #e5e7e8" data-uk-accordion>
      <li class="uk-margin-remove" style="border-top: 1px solid #e5e7e8">
        <a class="uk-accordion-title" style="padding-top: 12px; padding-bottom: 12px" href="#">Product Description</a>
        <div class="uk-accordion-content uk-margin-remove">
          <div class="uk-margin-small-bottom uk-text-small">
            <p>
              {{ breakdownText }}
            </p>
          </div>
        </div>
      </li>
    </ul>
    <div v-if="loading" class="uk-overlay-default vb-overlay-cart uk-position-cover" />
    <div v-if="loading" class="uk-position-center vb-spinner-cart-update" data-uk-spinner />
  </div>
</template>

<script>
import UIkit from 'uikit'
import { mapActions } from 'vuex'

import SizeChartButton from './SizeChartButton.vue'

export default {
  name: 'ProductSelector',
  components: { SizeChartButton },
  props: {
    json: {
      type: Array,
      default: () => [],
    },
    fbJson: {
      type: Array,
      default: () => [],
    },
    product: {
      type: Object,
      default: () => {},
    },
    breakdown: {
      type: Array,
      default: () => [],
    },
    wizardRoute: {
      type: String,
      default: '',
    },
    contactRoute: {
      type: String,
      default: '',
    },
    csrf: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedSize: undefined,
      loading: false,
      error: false,
    }
  },
  computed: {
    breakdownText() {
      return (
        this.breakdown?.reduce((acc, item) => {
          return `${acc} ${item.text}`
        }, '') || ''
      )
    },
  },
  mounted() {
    this.handleView()
  },
  methods: {
    ...mapActions('basket', ['addItem']),
    addToCart() {
      this.error = false

      if (!this.selectedSize) {
        this.error = true
      } else {
        this.addItem({ ...this.product, quantity: 1, size: this.selectedSize })
        UIkit.offcanvas('#offCanvasCart')?.show()
      }
    },
    toWizard() {
      this.error = false
      this.loading = true
      window.location.href = this.wizardRoute
      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    handleView() {
      this.$gtm.trackView('product-view', 'currentPath')

      this.$gtm.trackEvent({
        event: 'view_item',
        category: 'Products',
        action: 'view',
        label: 'User opened product view page',
        noninteraction: false,
        value: this.json[0].price,
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_item_list
        items: this.json,
      })
    },
  },
}
</script>
